/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, {useState} from 'react';
import { IPromoBannerViewProps } from './obrien-promo-banner';

import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

const PromoBannerView: React.FC<IPromoBannerViewProps> = props => {
    const {
        promoBannerProps,
        contentProps,
        closeButton,
        bannerMessages,
        PromoBannerTextProps,
        PromoBannerLinksProps,
        CarouselProps,
        handleLinks,
        handleText
    } = props;

    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const slides = bannerMessages && bannerMessages.map((message, index) => {
        return (
            <Node {...contentProps} key={index}>
                {message.text && <Node {...PromoBannerTextProps} text={message.text} onClick={handleText}/>}
                {message.links && message.links.length > 0 && <Node {...PromoBannerLinksProps} links={message.links} onClick={handleLinks} />}
                <Button color="warning" onClick={toggle}>Learn More</Button>
                <Modal isOpen={modal} toggle={toggle} >
                    <ModalHeader toggle={toggle}><h3>Notice on Shipping Delays</h3></ModalHeader>
                    <ModalBody className="flex-md">
                        <div className="forty">
                            <picture>
                                <img alt="2021-O'Brien-Boy-Life-Jacket-updated.jpg" src="https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MA1NRw?ver=763f&amp;m=6&amp;q=80" data-src="https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MA1NRw?ver=763f&amp;m=6&amp;q=80" title="2021-O'Brien-Boy-Life-Jacket-updated.jpg" className="msc-main_image msc_image ls-is-cached lazyloaded" width="1000" height="667"/>
                            </picture>
                        </div>
                        <div className="sixty">
                            <p>Unfortunately, our warehouse is a little backed up due to a large influx 
                                of orders creating shipping delays. 
                                As a result, order processing is currently 
                                taking up to 7 business days from the date of purchase. 
                                We are very sorry about any inconvenience and are doing 
                                everything we can to speed this up and process orders as efficiently as possible.</p>
                            <a className="btn btn-primary" href="https://www.obrien.com/contact">Contact Us</a>
                        </div>
                    </ModalBody>
                </Modal>

            </Node>
        );
    });

    return (
        <Module {...promoBannerProps}>
            <Node {...CarouselProps} items={slides} />
            {closeButton}
        </Module>
    );
};
export default PromoBannerView;
